import { AppShell } from '@mantine/core';
import classes from './AppLayout.module.css';

interface AppLayoutProps {
  header: React.FC<any>;
  navbar: React.FC<any>;
  mainContent: React.FC<any>;
  footer?: React.FC<any>;
  menuCollapsedDesktop: boolean
  menuCollapsedMobile: boolean
}
export function AppLayout({
  header,
  navbar,
  mainContent,
  menuCollapsedDesktop,
  menuCollapsedMobile
}: AppLayoutProps) {
  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 240,
        breakpoint: 'sm',
        collapsed: {
          mobile: !menuCollapsedMobile,
          desktop: !menuCollapsedDesktop
        },
      }}
      //EESTA ES LA FORMA CORRECTA DE HACER EL BACKGROUND COLOR (tEMPORALMENTE LO HACEMOS POR COMPONENT)
      // bg={'var(--mantine-washday-pages-bg-color)'}
      bg={'#fafafa'}
    >
      <AppShell.Header display={'flex'}>
        {header}
      </AppShell.Header>
      <AppShell.Navbar p="md" pt={0}>
        {navbar}
      </AppShell.Navbar>
      <AppShell.Main>
        {mainContent}
      </AppShell.Main>
    </AppShell>
  );
}
